import { getAuthHeaders } from "../AuthHeader/getAuthHeader";
import api from "../Interceptors";
import { ApiError } from "../ApiError";

export const getReportsProjects = async (
    page: number = 1,
    limit: number = 10,
    sortOrder?: "ASC" | "DESC",
) => {
    try {
        const authHeaders = await getAuthHeaders();
        const params: { page: number; limit: number; sort?: string } = {
            page,
            limit,
        };
        if (sortOrder) {
            params.sort = sortOrder;
        }
        const config = {
            headers: {
                "Content-Type": "application/json",
                ...authHeaders,
            },
            params,
        };
        const { data } = await api.get("/reports/projects", config);
        return data;
    } catch (error) {
        throw new ApiError(error);
    }
};

export const uploadReportFile = async (projectId: string, file: File) => {
    try {
        const authHeaders = await getAuthHeaders();
        const formData = new FormData();
        formData.append("file", file);
        const config = {
            headers: {
                ...authHeaders,
            },
        };
        const { data } = await api.post(
            `/reports/projects/${projectId}/upload`,
            formData,
            config,
        );
        return data;
    } catch (error) {
        throw new ApiError(error);
    }
};

/** POST /reports/upload – register report with projectId, reportUrl, and status. */
export const reportUpload = async (payload: {
    projectId: string;
    reportUrl: string;
    status: "report-uploaded";
}) => {
    try {
        const authHeaders = await getAuthHeaders();
        const config = {
            headers: {
                "Content-Type": "application/json",
                ...authHeaders,
            },
        };
        const { data } = await api.post("/reports/upload", payload, config);
        return data;
    } catch (error) {
        throw new ApiError(error);
    }
};
